export default "__VITE_ASSET__CQ03ge8$__"